import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/MarketplaceAffiliateCommissionFixedDates.graphql';
import { Query, QuerymarketplaceAffiliateCommissionFixedDatesArgs } from '../../__generated__/globalTypes';

export const useMarketplaceAffiliateCommissionFixedDatesQuery = (
  options?: QueryHookOptions<Query, QuerymarketplaceAffiliateCommissionFixedDatesArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerymarketplaceAffiliateCommissionFixedDatesArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useMarketplaceAffiliateCommissionFixedDatesLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerymarketplaceAffiliateCommissionFixedDatesArgs>
): QueryResult<Query, QuerymarketplaceAffiliateCommissionFixedDatesArgs> & {
  getMarketplaceAffiliateCommissionFixedDates: LazyQueryExecFunction<
    Query,
    QuerymarketplaceAffiliateCommissionFixedDatesArgs
  >;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getMarketplaceAffiliateCommissionFixedDates, result] = useLazyQuery<
    Query,
    QuerymarketplaceAffiliateCommissionFixedDatesArgs
  >(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getMarketplaceAffiliateCommissionFixedDates, ...result };
};

export const useMarketplaceAffiliateCommissionFixedDatesPromiseQuery = () => {
  const client = useApolloClient();

  const getMarketplaceAffiliateCommissionFixedDates = useCallback(
    (options?: Omit<QueryOptions<QuerymarketplaceAffiliateCommissionFixedDatesArgs, Query>, 'query'>) =>
      client.query<Query, QuerymarketplaceAffiliateCommissionFixedDatesArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getMarketplaceAffiliateCommissionFixedDates };
};
// Suspense Query Hooks
export const useMarketplaceAffiliateCommissionFixedDatesSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QuerymarketplaceAffiliateCommissionFixedDatesArgs>
) => {
  const result = useSuspenseQuery<Query, QuerymarketplaceAffiliateCommissionFixedDatesArgs>(QUERY, {
    ...options
  });

  return result;
};
